import { createContext as e } from "react";
const t = e({});
t.displayName = "QueryBuilderContext";
export {
  t as QueryBuilderContext
};
//# sourceMappingURL=index.es.js.map
